export class Terminal {
    id: number;
    terminalId: string;
    imei: string;
    portalId: number;
    deviceModelId: number;
    terminalStatus: boolean;
    isActive: boolean;
    userId: number;
}